import Vue from 'vue'
export default {
  search ({key, query}) {
    return Vue.http.get(window.API_URL + 'doctors/company_patients?term=' + query + '&key=' + key)
  },

  search_customer (query) {
    return Vue.http.post(window.API_URL + 'doctors/search_customers', {customer: query})
  },

  uploadDocument (formData) {
    Vue.http.post(window.API_URL + 'doctors/customer/documents', formData,
      {
        progress (e) {
          if (e.lengthComputable) {
            // let progress = e.loaded / e.total * 100
            // this.dispatch('configuration/updateUploadProgress', progress)
          }
        }
      }).then(response => {
        if (response.body.status === 200) {
          let sendData = {
            url: response.body.file_url[0],
            type: 'document',
            fileIntent: 'file_attachment'
            // fileName: fileList[0].name,
            // channelID: channelID,
            // consultId: consultId
          }
          return sendData
        } else {
        }
      }, response => {
      })
  },

  fetchSteps (customerId, fromDate, groupBy) {
    return Vue.http.get(window.API_URL + 'doctors/steps?customer_id=' + customerId + '&from_date=' + fromDate + '&group_by=' + groupBy)
  }
}



// WEBPACK FOOTER //
// ./src/api/customer/general.js